import React from 'react';
import styles from './staticPage.module.css';

/**
 * Shared layout for legal and static document pages.
 */
const StaticPage = ({ title, subtitle, children }) => {
  return (
    <div className={styles.wrap}>
      <article className={styles.documentCard}>
        {title && <h1 className={styles.title}>{title}</h1>}
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        {children}
      </article>
    </div>
  );
};

export default StaticPage;
